var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('p',[_vm._v("We're having trouble loading your impact.")]),_c('img',{staticClass:"refresh-button",attrs:{"role":"button","alt":"Refresh impact report","src":_vm.refreshIcon},on:{"click":_vm.onRefresh}}),_c('p',{staticClass:"try-again-text"},[_vm._v("Try again")])])
}
var staticRenderFns = []

export { render, staticRenderFns }